import React from "react";
import Team from "../common/Team";

interface IProps {
  toggleGalleryModal: () => void;
}

const Map: React.FC<IProps> = ({ toggleGalleryModal }) => {
  const teamImagesArray: string[] = [
    "/skill/team/skill-team-1.png",
    "/skill/team/skill-team-2.png",
    "/skill/team/skill-team-3.png",
    "/skill/team/skill-team-4.png",
    "/skill/team/skill-team-5.png",
    "/skill/team/skill-team-6.png",
  ];
  return (
    <div>
      <div className="flex justify-center items-center w-full">
        <h3 className=" text-white text-center sm:text-xl md:text-2xl lg:text-4xl xl:text-5xl max-w-5xl xl:leading-tight w-full  font-light">
          Dream Weavers is promoting Skill Development with over 20+ Skill
          Development Centers across different parts of India!
        </h3>
      </div>
      <div className="py-5 sm:py-7 lg:py-16 flex justify-center items-center">
        <img src="/skill/new-map.svg" alt="" className="w-full max-w-[45rem]" />
      </div>
      <div className="py-5 xl:px-8">
        <Team
          headingHide={true}
          toggleGalleryModal={toggleGalleryModal}
          text="A Glimpse of an Empowered India."
          imagesArray={teamImagesArray}
        />
      </div>
    </div>
  );
};

export default Map;
